function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useMemo } from 'react';
import getDisplayName from '../../getDisplayName';
export default function wrapUiDisabledWidget(WrappedComponent) {
  var Wrapped = function Wrapped(props) {
    var options = props.options,
      rest = _objectWithoutProperties(props, ["options"]);
    var _optsWithUiDisabled = useMemo(function () {
      var groupedOptions = options.groupedOptions,
        enumOptions = options.enumOptions,
        enumDisabled = options.enumDisabled;
      var result = _objectSpread({}, options);
      if (enumDisabled && enumDisabled.length > 0) {
        var flagReadOnly = function flagReadOnly(option) {
          var isReadOnly = enumDisabled.indexOf(option.value) !== -1;
          return isReadOnly ? Object.assign({}, option, {
            disabled: true
          }) : option;
        };
        if (groupedOptions) {
          result.groupedOptions = options.groupedOptions.map(function (group) {
            var result = group;
            if (result.options && result.options.length) {
              result.options = result.options.map(function (option) {
                return flagReadOnly(option);
              });
            }
            return result;
          });
        }
        if (enumOptions) {
          result.enumOptions = options.enumOptions.map(function (option) {
            return flagReadOnly(option);
          });
        }
      }
      return result;
    }, [options]);
    return /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({
      options: _optsWithUiDisabled
    }, rest));
  };
  Wrapped.displayName = "WrapUiDisabledWidget(".concat(getDisplayName(WrappedComponent), ")");
  return Wrapped;
}